import {CommonIadlPdfDataProcessor} from '../export-care-plan-common-iadl-pdf-data';

export class AivdOtherPdfDataProcessor extends CommonIadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
